import { useState } from "react";
import { useTelegram } from "../hooks/useTelegram";
import RemoveBackground from "./RemoveBackground";
import PhotoSession from "./PhotoSession";
import "./MainScreen.css";

type Feature = "photosession" | "video" | "remove-bg" | "try-on" | null;

function MainScreen() {
  const { user, isReady } = useTelegram();
  const [selectedFeature, setSelectedFeature] = useState<Feature>(null);

  if (!isReady) {
    return (
      <div className="loading">
        <div className="spinner"></div>
      </div>
    );
  }

  const features = [
    {
      id: "photosession" as Feature,
      title: "Фотосессия по референсу",
      icon: "📸",
    },
    { id: "video" as Feature, title: "Создать видео", icon: "🎬" },
    { id: "remove-bg" as Feature, title: "Убрать фон", icon: "✂️" },
    { id: "try-on" as Feature, title: "Примерка одежды", icon: "👔" },
  ];

  if (selectedFeature) {
    return (
      <div className="feature-screen">
        <button className="back-btn" onClick={() => setSelectedFeature(null)}>
          ← Назад
        </button>
        {selectedFeature === "remove-bg" && <RemoveBackground />}
        {selectedFeature === "photosession" && <PhotoSession />}
        {selectedFeature &&
          selectedFeature !== "remove-bg" &&
          selectedFeature !== "photosession" && (
            <div className="feature-content">
              <h2>{features.find((f) => f.id === selectedFeature)?.title}</h2>
              <p>Функция в разработке...</p>
            </div>
          )}
      </div>
    );
  }

  return (
    <div className="main-screen">
      <header className="header">
        <h1>ФотАй</h1>
        <p className="subtitle">AI обработка фотографий</p>
        {user && <p className="user-info">Привет, {user.first_name}!</p>}
      </header>

      <div className="features-grid">
        {features.map((feature) => (
          <button
            key={feature.id}
            className="feature-card"
            onClick={() => setSelectedFeature(feature.id)}
          >
            <div className="feature-icon">{feature.icon}</div>
            <div className="feature-title">{feature.title}</div>
          </button>
        ))}
      </div>
    </div>
  );
}

export default MainScreen;
